import clsx from 'clsx';
import { InlineSvg } from 'components/svg';
import { useLayout } from 'layouts/core/layout.context';
import { FC } from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { WithChildren } from 'ts-types';
import { checkIsActive } from 'utils/routers';

type HighlightInfo = {
  text?: string;
};

type Props = {
  to: string;
  title: string;
  icon?: string;
  fontIcon?: string;
  hasBullet?: boolean;
  extraInfo?: HighlightInfo;
};

const AsideMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  extraInfo
}) => {
  const { pathname } = useLocation();
  const isActive = checkIsActive(pathname, to);
  const { config } = useLayout();
  const { aside } = config;

  return (
    <div className="menu-item">
      <Link className={clsx('menu-link without-sub', { active: isActive })} to={to}>
        {hasBullet && (
          <span className="menu-bullet">
            <span className="bullet bullet-dot"></span>
          </span>
        )}
        {icon && aside.menuIcon === 'svg' && (
          <span className="menu-icon">
            <InlineSvg path={icon} className="svg-icon-2" />
          </span>
        )}
        {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-3', fontIcon)}></i>}
        <span className="menu-title">{title}</span>
        {extraInfo?.text && <span className="badge badge-primary badge-sm badge-circle">{extraInfo.text}</span>}
      </Link>
      {children}
    </div>
  );
};

export { AsideMenuItem };
